import { useMutation, useQuery, UseMutationOptions, UseQueryOptions } from '@tanstack/react-query'
import { TUseMutationOptions, TUseQueryOptions } from 'core/query/type'
import {
  TGetFinanceOtherLogListParams,
  TGetFinanceOtherLogListResponse,
  getFinanceOtherLogList,
  TPostCapitalValidateAddressParams,
  TPostCapitalValidateAddressResponse,
  postCapitalValidateAddress,
  TPostCapitalWithdrawAddressCoinParams,
  TPostCapitalWithdrawAddressCoinResponse,
  postCapitalWithdrawAddressCoin,
  TGetCapitalWithdrawCheckParams,
  TGetCapitalWithdrawCheckResponse,
  getCapitalWithdrawCheck,
  TGetCapitalValidateAddressParams,
  TGetCapitalValidateAddressResponse,
  getCapitalValidateAddress,
  TGetFinanceOwnCointypeListParams,
  TGetFinanceOwnCointypeListResponse,
  getFinanceOwnCointypeList,
  TGetCapitalGetSystemCoinTypeListParams,
  TGetCapitalGetSystemCoinTypeListResponse,
  getCapitalGetSystemCoinTypeList,
  TPostCapitalGetSystemCoinTypeListParams,
  TPostCapitalGetSystemCoinTypeListResponse,
  postCapitalGetSystemCoinTypeList,
  TGetCapitalGetNetworkByAddrParams,
  TGetCapitalGetNetworkByAddrResponse,
  getCapitalGetNetworkByAddr,
  TPostCapitalCreateWithdrawAddress1659664748250Params,
  TPostCapitalCreateWithdrawAddress1659664748250Response,
  postCapitalCreateWithdrawAddress1659664748250,
  TPostCapitalQueryWithdrawAddressParams,
  TPostCapitalQueryWithdrawAddressResponse,
  postCapitalQueryWithdrawAddress,
  TGetFinanceContractCommissionLogListParams,
  TGetFinanceContractCommissionLogListResponse,
  getFinanceContractCommissionLogList,
  TGetFinanceContractCommissionSumListParams,
  TGetFinanceContractCommissionSumListResponse,
  getFinanceContractCommissionSumList,
  TPostRechargeCoinAddressParams,
  TPostRechargeCoinAddressResponse,
  postRechargeCoinAddress,
  TGetRechargeAddressCreateParams,
  TGetRechargeAddressCreateResponse,
  getRechargeAddressCreate,
  TPostRechargeAddressListParams,
  TPostRechargeAddressListResponse,
  postRechargeAddressList,
  TPostRechargeAddressRemarkParams,
  TPostRechargeAddressRemarkResponse,
  postRechargeAddressRemark,
  TPostRechargeAddressSelectedParams,
  TPostRechargeAddressSelectedResponse,
  postRechargeAddressSelected,
  TPostCapitalTransferPrecheckParams,
  TPostCapitalTransferPrecheckResponse,
  postCapitalTransferPrecheck,
  TPostCapitalTransferSubmitParams,
  TPostCapitalTransferSubmitResponse,
  postCapitalTransferSubmit,
  TPostV1CapitalWithdrawCheckParams,
  TPostV1CapitalWithdrawCheckResponse,
  postV1CapitalWithdrawCheck,
  TGetFinanceOtherByTypeLogListParams,
  TGetFinanceOtherByTypeLogListResponse,
  getFinanceOtherByTypeLogList,
  TGetCapitalUniversalAddressNetworksParams,
  TGetCapitalUniversalAddressNetworksResponse,
  getCapitalUniversalAddressNetworks,
  TPostCapitalWithdrawEditAddressSettingParams,
  TPostCapitalWithdrawEditAddressSettingResponse,
  postCapitalWithdrawEditAddressSetting,
  TGetCapitalWithdrawGetAddressSettingParams,
  TGetCapitalWithdrawGetAddressSettingResponse,
  getCapitalWithdrawGetAddressSetting,
  TGetFinanceRechargeWithdrawListParams,
  TGetFinanceRechargeWithdrawListResponse,
  getFinanceRechargeWithdrawList,
  TPostTestCapitalWithdrawEditAddressSettingParams,
  TPostTestCapitalWithdrawEditAddressSettingResponse,
  postTestCapitalWithdrawEditAddressSetting,
  TPostV3CapitalListWithdrawAddressParams,
  TPostV3CapitalListWithdrawAddressResponse,
  postV3CapitalListWithdrawAddress,
  TPostCapitalWithdrawAddressListParams,
  TPostCapitalWithdrawAddressListResponse,
  postCapitalWithdrawAddressList,
  TPostCapitalWithdrawAddressRemarkEditParams,
  TPostCapitalWithdrawAddressRemarkEditResponse,
  postCapitalWithdrawAddressRemarkEdit,
  TGetFinanceAirdropLogListParams,
  TGetFinanceAirdropLogListResponse,
  getFinanceAirdropLogList,
  TGetFinanceTransferHistoryListParams,
  TGetFinanceTransferHistoryListResponse,
  getFinanceTransferHistoryList,
  TGetWalletTransferTypesParams,
  TGetWalletTransferTypesResponse,
  getWalletTransferTypes,
  TGetTransferGetTypeParams,
  TGetTransferGetTypeResponse,
  getTransferGetType,
  TGetWalletTransferInfosParams,
  TGetWalletTransferInfosResponse,
  getWalletTransferInfos,
  TGetV1WalletTransferTypesParams,
  TGetV1WalletTransferTypesResponse,
  getV1WalletTransferTypes,
  TGetFinanceRechargeLogListParams,
  TGetFinanceRechargeLogListResponse,
  getFinanceRechargeLogList,
  TGetFinanceTransferLogListParams,
  TGetFinanceTransferLogListResponse,
  getFinanceTransferLogList,
  TGetFinanceWithdrawLogListParams,
  TGetFinanceWithdrawLogListResponse,
  getFinanceWithdrawLogList,
  TGetV2CapitalListWithdrawAddressParams,
  TGetV2CapitalListWithdrawAddressResponse,
  getV2CapitalListWithdrawAddress,
  TPostCapitalCreateWithdrawAddressParams,
  TPostCapitalCreateWithdrawAddressResponse,
  postCapitalCreateWithdrawAddress,
  TPostWithdrawCancelParams,
  TPostWithdrawCancelResponse,
  postWithdrawCancel,
  TGetV2CapitalValidateAddressParams,
  TGetV2CapitalValidateAddressResponse,
  getV2CapitalValidateAddress,
  TGetV2CapitalRemoveWithdrawAddressParams,
  TGetV2CapitalRemoveWithdrawAddressResponse,
  getV2CapitalRemoveWithdrawAddress,
  TGetV2CapitalCoinWithdrawInfoParams,
  TGetV2CapitalCoinWithdrawInfoResponse,
  getV2CapitalCoinWithdrawInfo,
  TPostCapitalWithdrawParams,
  TPostCapitalWithdrawResponse,
  TGetCapitalWithdrawAddressCoinParams,
  TGetCapitalWithdrawAddressCoinResponse,
  getCapitalWithdrawAddressCoin,
  TGetListWithdrawCoinParams,
  TGetListWithdrawCoinResponse,
  getListWithdrawCoin,
  TGetTransferInfoParams,
  TGetTransferInfoResponse,
  getTransferInfo,
  TGetWalletInfoParams,
  TGetWalletInfoResponse,
  getWalletInfo,
} from 'core/service/yapi/hk-web/HotcoinControllerV4/api'

import { postCapitalWithdraw } from 'core/service/fixLegacyAPI/hk-web/HotcoinControllerV4/api'

// 充提币相关接口
// 分页查询其他记录
export const useGetFinanceOtherLogListQuery = (
  params?: TGetFinanceOtherLogListParams,
  options?: TUseQueryOptions<TGetFinanceOtherLogListResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['HotcoinControllerV4', 'FinanceOtherLogList', 'GET', ...Object.values(params || {})],
    queryFn: () => getFinanceOtherLogList(params),
  })
}

// validateAddress
export const usePostCapitalValidateAddressMutation = (
  mutationOptions?: TUseMutationOptions<TPostCapitalValidateAddressResponse, TPostCapitalValidateAddressParams>
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['HotcoinControllerV4', 'CapitalValidateAddress', 'Post'],
    mutationFn: (params?: TPostCapitalValidateAddressParams) => postCapitalValidateAddress(params),
  })
}

// withdrawAddressCoin
export const usePostCapitalWithdrawAddressCoinMutation = (
  mutationOptions?: TUseMutationOptions<TPostCapitalWithdrawAddressCoinResponse, TPostCapitalWithdrawAddressCoinParams>
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['HotcoinControllerV4', 'CapitalWithdrawAddressCoin', 'Post'],
    mutationFn: (params?: TPostCapitalWithdrawAddressCoinParams) => postCapitalWithdrawAddressCoin(params),
  })
}

// 虚拟币提现申请前校验
export const useGetCapitalWithdrawCheckQuery = (
  params?: TGetCapitalWithdrawCheckParams,
  options?: TUseQueryOptions<TGetCapitalWithdrawCheckResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['HotcoinControllerV4', 'CapitalWithdrawCheck', 'GET', ...Object.values(params || {})],
    queryFn: () => getCapitalWithdrawCheck(params),
  })
}

// validateAddress
export const useGetCapitalValidateAddressQuery = (
  params?: TGetCapitalValidateAddressParams,
  options?: TUseQueryOptions<TGetCapitalValidateAddressResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['HotcoinControllerV4', 'CapitalValidateAddress', 'GET', ...Object.values(params || {})],
    queryFn: () => getCapitalValidateAddress(params),
  })
}

// 财务日志个人币种
export const useGetFinanceOwnCointypeListQuery = (
  params?: TGetFinanceOwnCointypeListParams,
  options?: TUseQueryOptions<TGetFinanceOwnCointypeListResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['HotcoinControllerV4', 'FinanceOwnCointypeList', 'GET', ...Object.values(params || {})],
    queryFn: () => getFinanceOwnCointypeList(params),
  })
}

// getSystemCoinTypeList
export const useGetCapitalGetSystemCoinTypeListQuery = (
  params?: TGetCapitalGetSystemCoinTypeListParams,
  options?: TUseQueryOptions<TGetCapitalGetSystemCoinTypeListResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['HotcoinControllerV4', 'CapitalGetSystemCoinTypeList', 'GET', ...Object.values(params || {})],
    queryFn: () => getCapitalGetSystemCoinTypeList(params),
  })
}

// getSystemCoinTypeList
export const usePostCapitalGetSystemCoinTypeListMutation = (
  mutationOptions?: TUseMutationOptions<
    TPostCapitalGetSystemCoinTypeListResponse,
    TPostCapitalGetSystemCoinTypeListParams
  >
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['HotcoinControllerV4', 'CapitalGetSystemCoinTypeList', 'Post'],
    mutationFn: (params?: TPostCapitalGetSystemCoinTypeListParams) => postCapitalGetSystemCoinTypeList(params),
  })
}

// 查询符合地址类型的网络
export const useGetCapitalGetNetworkByAddrQuery = (
  params?: TGetCapitalGetNetworkByAddrParams,
  options?: TUseQueryOptions<TGetCapitalGetNetworkByAddrResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['HotcoinControllerV4', 'CapitalGetNetworkByAddr', 'GET', ...Object.values(params || {})],
    queryFn: () => getCapitalGetNetworkByAddr(params),
  })
}

// 根据币种id和地址查询提现地址
export const usePostCapitalCreateWithdrawAddress1659664748250Mutation = (
  mutationOptions?: TUseMutationOptions<
    TPostCapitalCreateWithdrawAddress1659664748250Response,
    TPostCapitalCreateWithdrawAddress1659664748250Params
  >
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['HotcoinControllerV4', 'CapitalCreateWithdrawAddress1659664748250', 'Post'],
    mutationFn: (params?: TPostCapitalCreateWithdrawAddress1659664748250Params) =>
      postCapitalCreateWithdrawAddress1659664748250(params),
  })
}

// getWithdrawAddress
export const usePostCapitalQueryWithdrawAddressMutation = (
  mutationOptions?: TUseMutationOptions<
    TPostCapitalQueryWithdrawAddressResponse,
    TPostCapitalQueryWithdrawAddressParams
  >
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['HotcoinControllerV4', 'CapitalQueryWithdrawAddress', 'Post'],
    mutationFn: (params?: TPostCapitalQueryWithdrawAddressParams) => postCapitalQueryWithdrawAddress(params),
  })
}

// 分页查询合约邀请返佣记录
export const useGetFinanceContractCommissionLogListQuery = (
  params?: TGetFinanceContractCommissionLogListParams,
  options?: TUseQueryOptions<TGetFinanceContractCommissionLogListResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['HotcoinControllerV4', 'FinanceContractCommissionLogList', 'GET', ...Object.values(params || {})],
    queryFn: () => getFinanceContractCommissionLogList(params),
  })
}

// 分页统计合约邀请返佣记录
export const useGetFinanceContractCommissionSumListQuery = (
  params?: TGetFinanceContractCommissionSumListParams,
  options?: TUseQueryOptions<TGetFinanceContractCommissionSumListResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['HotcoinControllerV4', 'FinanceContractCommissionSumList', 'GET', ...Object.values(params || {})],
    queryFn: () => getFinanceContractCommissionSumList(params),
  })
}

// 获取选中充币地址
export const usePostRechargeCoinAddressMutation = (
  mutationOptions?: TUseMutationOptions<TPostRechargeCoinAddressResponse, TPostRechargeCoinAddressParams>
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['HotcoinControllerV4', 'RechargeCoinAddress', 'Post'],
    mutationFn: (params?: TPostRechargeCoinAddressParams) => postRechargeCoinAddress(params),
  })
}

// 新增虚拟币充值地址
export const useGetRechargeAddressCreateQuery = (
  params?: TGetRechargeAddressCreateParams,
  options?: TUseQueryOptions<TGetRechargeAddressCreateResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['HotcoinControllerV4', 'RechargeAddressCreate', 'GET', ...Object.values(params || {})],
    queryFn: () => getRechargeAddressCreate(params),
  })
}

// 获取充币地址列表
export const usePostRechargeAddressListMutation = (
  mutationOptions?: TUseMutationOptions<TPostRechargeAddressListResponse, TPostRechargeAddressListParams>
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['HotcoinControllerV4', 'RechargeAddressList', 'Post'],
    mutationFn: (params?: TPostRechargeAddressListParams) => postRechargeAddressList(params),
  })
}

// 编辑充币地址名称
export const usePostRechargeAddressRemarkMutation = (
  mutationOptions?: TUseMutationOptions<TPostRechargeAddressRemarkResponse, TPostRechargeAddressRemarkParams>
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['HotcoinControllerV4', 'RechargeAddressRemark', 'Post'],
    mutationFn: (params?: TPostRechargeAddressRemarkParams) => postRechargeAddressRemark(params),
  })
}

// 选用当前充币地址
export const usePostRechargeAddressSelectedMutation = (
  mutationOptions?: TUseMutationOptions<TPostRechargeAddressSelectedResponse, TPostRechargeAddressSelectedParams>
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['HotcoinControllerV4', 'RechargeAddressSelected', 'Post'],
    mutationFn: (params?: TPostRechargeAddressSelectedParams) => postRechargeAddressSelected(params),
  })
}

// 内部转账转账前校验
export const usePostCapitalTransferPrecheckMutation = (
  mutationOptions?: TUseMutationOptions<TPostCapitalTransferPrecheckResponse, TPostCapitalTransferPrecheckParams>
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['HotcoinControllerV4', 'CapitalTransferPrecheck', 'Post'],
    mutationFn: (params?: TPostCapitalTransferPrecheckParams) => postCapitalTransferPrecheck(params),
  })
}

// 内部转账提交(包括4项验证)
export const usePostCapitalTransferSubmitMutation = (
  mutationOptions?: TUseMutationOptions<TPostCapitalTransferSubmitResponse, TPostCapitalTransferSubmitParams>
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['HotcoinControllerV4', 'CapitalTransferSubmit', 'Post'],
    mutationFn: (params?: TPostCapitalTransferSubmitParams) => postCapitalTransferSubmit(params),
  })
}

// 虚拟币提现申请前校验V1
export const usePostV1CapitalWithdrawCheckMutation = (
  mutationOptions?: TUseMutationOptions<TPostV1CapitalWithdrawCheckResponse, TPostV1CapitalWithdrawCheckParams>
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['HotcoinControllerV4', 'V1CapitalWithdrawCheck', 'Post'],
    mutationFn: (params?: TPostV1CapitalWithdrawCheckParams) => postV1CapitalWithdrawCheck(params),
  })
}

// 分页根据类型查询其他记录
export const useGetFinanceOtherByTypeLogListQuery = (
  params?: TGetFinanceOtherByTypeLogListParams,
  options?: TUseQueryOptions<TGetFinanceOtherByTypeLogListResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['HotcoinControllerV4', 'FinanceOtherByTypeLogList', 'GET', ...Object.values(params || {})],
    queryFn: () => getFinanceOtherByTypeLogList(params),
  })
}

// 查询支持通用提现地址的网络列表
export const useGetCapitalUniversalAddressNetworksQuery = (
  params?: TGetCapitalUniversalAddressNetworksParams,
  options?: TUseQueryOptions<TGetCapitalUniversalAddressNetworksResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['HotcoinControllerV4', 'CapitalUniversalAddressNetworks', 'GET', ...Object.values(params || {})],
    queryFn: () => getCapitalUniversalAddressNetworks(params),
  })
}

// 编辑提现地址设置
export const usePostCapitalWithdrawEditAddressSettingMutation = (
  mutationOptions?: TUseMutationOptions<
    TPostCapitalWithdrawEditAddressSettingResponse,
    TPostCapitalWithdrawEditAddressSettingParams
  >
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['HotcoinControllerV4', 'CapitalWithdrawEditAddressSetting', 'Post'],
    mutationFn: (params?: TPostCapitalWithdrawEditAddressSettingParams) =>
      postCapitalWithdrawEditAddressSetting(params),
  })
}

// 查询提现地址设置
export const useGetCapitalWithdrawGetAddressSettingQuery = (
  params?: TGetCapitalWithdrawGetAddressSettingParams,
  options?: TUseQueryOptions<TGetCapitalWithdrawGetAddressSettingResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['HotcoinControllerV4', 'CapitalWithdrawGetAddressSetting', 'GET', ...Object.values(params || {})],
    queryFn: () => getCapitalWithdrawGetAddressSetting(params),
  })
}

// 查询最近充提记录列表
export const useGetFinanceRechargeWithdrawListQuery = (
  params?: TGetFinanceRechargeWithdrawListParams,
  options?: TUseQueryOptions<TGetFinanceRechargeWithdrawListResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['HotcoinControllerV4', 'FinanceRechargeWithdrawList', 'GET', ...Object.values(params || {})],
    queryFn: () => getFinanceRechargeWithdrawList(params),
  })
}

// 编辑提现地址设置
export const usePostTestCapitalWithdrawEditAddressSettingMutation = (
  mutationOptions?: TUseMutationOptions<
    TPostTestCapitalWithdrawEditAddressSettingResponse,
    TPostTestCapitalWithdrawEditAddressSettingParams
  >
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['HotcoinControllerV4', 'TestCapitalWithdrawEditAddressSetting', 'Post'],
    mutationFn: (params?: TPostTestCapitalWithdrawEditAddressSettingParams) =>
      postTestCapitalWithdrawEditAddressSetting(params),
  })
}

// 根据币种查询提币地址
export const usePostV3CapitalListWithdrawAddressMutation = (
  mutationOptions?: TUseMutationOptions<
    TPostV3CapitalListWithdrawAddressResponse,
    TPostV3CapitalListWithdrawAddressParams
  >
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['HotcoinControllerV4', 'V3CapitalListWithdrawAddress', 'Post'],
    mutationFn: (params?: TPostV3CapitalListWithdrawAddressParams) => postV3CapitalListWithdrawAddress(params),
  })
}

// 地址簿分页查询查询提现地址
export const usePostCapitalWithdrawAddressListMutation = (
  mutationOptions?: TUseMutationOptions<TPostCapitalWithdrawAddressListResponse, TPostCapitalWithdrawAddressListParams>
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['HotcoinControllerV4', 'CapitalWithdrawAddressList', 'Post'],
    mutationFn: (params?: TPostCapitalWithdrawAddressListParams) => postCapitalWithdrawAddressList(params),
  })
}

// 编辑提现地址备注
export const usePostCapitalWithdrawAddressRemarkEditMutation = (
  mutationOptions?: TUseMutationOptions<
    TPostCapitalWithdrawAddressRemarkEditResponse,
    TPostCapitalWithdrawAddressRemarkEditParams
  >
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['HotcoinControllerV4', 'CapitalWithdrawAddressRemarkEdit', 'Post'],
    mutationFn: (params?: TPostCapitalWithdrawAddressRemarkEditParams) => postCapitalWithdrawAddressRemarkEdit(params),
  })
}

// 分页查询空投(startup分发、startup认购)记录
export const useGetFinanceAirdropLogListQuery = (
  params?: TGetFinanceAirdropLogListParams,
  options?: TUseQueryOptions<TGetFinanceAirdropLogListResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['HotcoinControllerV4', 'FinanceAirdropLogList', 'GET', ...Object.values(params || {})],
    queryFn: () => getFinanceAirdropLogList(params),
  })
}

// 查询用户钱包划转记录
export const useGetFinanceTransferHistoryListQuery = (
  params?: TGetFinanceTransferHistoryListParams,
  options?: TUseQueryOptions<TGetFinanceTransferHistoryListResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['HotcoinControllerV4', 'FinanceTransferHistoryList', 'GET', ...Object.values(params || {})],
    queryFn: () => getFinanceTransferHistoryList(params),
  })
}

// 资金划转类型列表
export const useGetWalletTransferTypesQuery = (
  params?: TGetWalletTransferTypesParams,
  options?: TUseQueryOptions<TGetWalletTransferTypesResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['HotcoinControllerV4', 'WalletTransferTypes', 'GET', ...Object.values(params || {})],
    queryFn: () => getWalletTransferTypes(params),
  })
}

// 查询划转账户类型
export const useGetTransferGetTypeQuery = (
  params?: TGetTransferGetTypeParams,
  options?: TUseQueryOptions<TGetTransferGetTypeResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['HotcoinControllerV4', 'TransferGetType', 'GET', ...Object.values(params || {})],
    queryFn: () => getTransferGetType(params),
  })
}

// 查询所有账户详情
export const useGetWalletTransferInfosQuery = (
  params?: TGetWalletTransferInfosParams,
  options?: TUseQueryOptions<TGetWalletTransferInfosResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['HotcoinControllerV4', 'WalletTransferInfos', 'GET', ...Object.values(params || {})],
    queryFn: () => getWalletTransferInfos(params),
  })
}

// 资金划转类型列表V1
export const useGetV1WalletTransferTypesQuery = (
  params?: TGetV1WalletTransferTypesParams,
  options?: TUseQueryOptions<TGetV1WalletTransferTypesResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['HotcoinControllerV4', 'V1WalletTransferTypes', 'GET', ...Object.values(params || {})],
    queryFn: () => getV1WalletTransferTypes(params),
  })
}

// 分页查询充币记录
export const useGetFinanceRechargeLogListQuery = (
  params?: TGetFinanceRechargeLogListParams,
  options?: TUseQueryOptions<TGetFinanceRechargeLogListResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['HotcoinControllerV4', 'FinanceRechargeLogList', 'GET', ...Object.values(params || {})],
    queryFn: () => getFinanceRechargeLogList(params),
  })
}

// 分页查询划转记录
export const useGetFinanceTransferLogListQuery = (
  params?: TGetFinanceTransferLogListParams,
  options?: TUseQueryOptions<TGetFinanceTransferLogListResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['HotcoinControllerV4', 'FinanceTransferLogList', 'GET', ...Object.values(params || {})],
    queryFn: () => getFinanceTransferLogList(params),
  })
}

// 分页查询提币记录
export const useGetFinanceWithdrawLogListQuery = (
  params?: TGetFinanceWithdrawLogListParams,
  options?: TUseQueryOptions<TGetFinanceWithdrawLogListResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['HotcoinControllerV4', 'FinanceWithdrawLogList', 'GET', ...Object.values(params || {})],
    queryFn: () => getFinanceWithdrawLogList(params),
  })
}

// 分页查询提币地址
export const useGetV2CapitalListWithdrawAddressQuery = (
  params?: TGetV2CapitalListWithdrawAddressParams,
  options?: TUseQueryOptions<TGetV2CapitalListWithdrawAddressResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['HotcoinControllerV4', 'V2CapitalListWithdrawAddress', 'GET', ...Object.values(params || {})],
    queryFn: () => getV2CapitalListWithdrawAddress(params),
  })
}

// createWithdrawAddress
export const usePostCapitalCreateWithdrawAddressMutation = (
  mutationOptions?: TUseMutationOptions<
    TPostCapitalCreateWithdrawAddressResponse,
    TPostCapitalCreateWithdrawAddressParams
  >
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['HotcoinControllerV4', 'CapitalCreateWithdrawAddress', 'Post'],
    mutationFn: (params?: TPostCapitalCreateWithdrawAddressParams) => postCapitalCreateWithdrawAddress(params),
  })
}

// 提币撤销
export const usePostWithdrawCancelMutation = (
  mutationOptions?: TUseMutationOptions<TPostWithdrawCancelResponse, TPostWithdrawCancelParams>
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['HotcoinControllerV4', 'WithdrawCancel', 'Post'],
    mutationFn: (params?: TPostWithdrawCancelParams) => postWithdrawCancel(params),
  })
}

// 提币地址校验
export const useGetV2CapitalValidateAddressQuery = (
  params?: TGetV2CapitalValidateAddressParams,
  options?: TUseQueryOptions<TGetV2CapitalValidateAddressResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['HotcoinControllerV4', 'V2CapitalValidateAddress', 'GET', ...Object.values(params || {})],
    queryFn: () => getV2CapitalValidateAddress(params),
  })
}

// 删除提币地址
export const useGetV2CapitalRemoveWithdrawAddressQuery = (
  params?: TGetV2CapitalRemoveWithdrawAddressParams,
  options?: TUseQueryOptions<TGetV2CapitalRemoveWithdrawAddressResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['HotcoinControllerV4', 'V2CapitalRemoveWithdrawAddress', 'GET', ...Object.values(params || {})],
    queryFn: () => getV2CapitalRemoveWithdrawAddress(params),
  })
}

// 获取提币所需参数
export const useGetV2CapitalCoinWithdrawInfoQuery = (
  params?: TGetV2CapitalCoinWithdrawInfoParams,
  options?: TUseQueryOptions<TGetV2CapitalCoinWithdrawInfoResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['HotcoinControllerV4', 'V2CapitalCoinWithdrawInfo', 'GET', ...Object.values(params || {})],
    queryFn: () => getV2CapitalCoinWithdrawInfo(params),
  })
}

// 虚拟币提现申请(包括4项验证)
export const usePostCapitalWithdrawMutation = (
  mutationOptions?: TUseMutationOptions<TPostCapitalWithdrawResponse, TPostCapitalWithdrawParams>
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['HotcoinControllerV4', 'CapitalWithdraw', 'Post'],
    mutationFn: (params?: TPostCapitalWithdrawParams) => postCapitalWithdraw(params),
  })
}

// withdrawAddressCoin
export const useGetCapitalWithdrawAddressCoinQuery = (
  params?: TGetCapitalWithdrawAddressCoinParams,
  options?: TUseQueryOptions<TGetCapitalWithdrawAddressCoinResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['HotcoinControllerV4', 'CapitalWithdrawAddressCoin', 'GET', ...Object.values(params || {})],
    queryFn: () => getCapitalWithdrawAddressCoin(params),
  })
}

// 查询可提现币种信息
export const useGetListWithdrawCoinQuery = (
  params?: TGetListWithdrawCoinParams,
  options?: TUseQueryOptions<TGetListWithdrawCoinResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['HotcoinControllerV4', 'ListWithdrawCoin', 'GET', ...Object.values(params || {})],
    queryFn: () => getListWithdrawCoin(params),
  })
}

// 获取可划转币种列表
export const useGetTransferInfoQuery = (
  params?: TGetTransferInfoParams,
  options?: TUseQueryOptions<TGetTransferInfoResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['HotcoinControllerV4', 'TransferInfo', 'GET', ...Object.values(params || {})],
    queryFn: () => getTransferInfo(params),
  })
}

// 查询用户钱包信息
export const useGetWalletInfoQuery = (
  params?: TGetWalletInfoParams,
  options?: TUseQueryOptions<TGetWalletInfoResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['HotcoinControllerV4', 'WalletInfo', 'GET', ...Object.values(params || {})],
    queryFn: () => getWalletInfo(params),
  })
}
